module.exports = __webpack_public_path__ + "static/media/calendar.e4258d53.svg";